"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.list = list;
exports.action = action;
exports.fetch = fetch;
exports.downloadFile = downloadFile;
exports.download = download;
exports.uploadFileFinish = uploadFileFinish;
exports.getConfigurationWizardInfo = getConfigurationWizardInfo;
exports.setConfigurationWizardInfo = setConfigurationWizardInfo;
exports.checkAdminPwd = checkAdminPwd;
exports.SAVE_PERSISTENCE_COLUMN_URL = exports.PERSISTENCE_COLUMN_URL = exports.AUTHENTICAION_IN_DWONFILE_URL = void 0;

require("regenerator-runtime/runtime.js");

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.parse-float.js");

require("core-js/modules/es.array.find-index.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.array-buffer.constructor.js");

require("core-js/modules/es.array-buffer.slice.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.typed-array.uint8-array.js");

require("core-js/modules/es.typed-array.copy-within.js");

require("core-js/modules/es.typed-array.every.js");

require("core-js/modules/es.typed-array.fill.js");

require("core-js/modules/es.typed-array.filter.js");

require("core-js/modules/es.typed-array.find.js");

require("core-js/modules/es.typed-array.find-index.js");

require("core-js/modules/es.typed-array.for-each.js");

require("core-js/modules/es.typed-array.includes.js");

require("core-js/modules/es.typed-array.index-of.js");

require("core-js/modules/es.typed-array.iterator.js");

require("core-js/modules/es.typed-array.join.js");

require("core-js/modules/es.typed-array.last-index-of.js");

require("core-js/modules/es.typed-array.map.js");

require("core-js/modules/es.typed-array.reduce.js");

require("core-js/modules/es.typed-array.reduce-right.js");

require("core-js/modules/es.typed-array.reverse.js");

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.slice.js");

require("core-js/modules/es.typed-array.some.js");

require("core-js/modules/es.typed-array.sort.js");

require("core-js/modules/es.typed-array.subarray.js");

require("core-js/modules/es.typed-array.to-locale-string.js");

require("core-js/modules/es.typed-array.to-string.js");

var _axios = _interopRequireDefault(require("axios"));

var _lodash = _interopRequireDefault(require("lodash"));

var _qs = _interopRequireDefault(require("qs"));

var _skAxios = _interopRequireWildcard3(require("sk-axios"));

var _utils = require("sk-web-framework/utils");

var _lang = _interopRequireDefault(require("@/lang"));

var _store = _interopRequireDefault(require("@/store"));

var moduleConfigWizard = 'rco/configWizard';
var ADMIN = "".concat(process.env.BASE_MODULE_API, "/admin");
var AUTHENTICAION_IN_DWONFILE_URL = 'skyengine_default_download_checker';
exports.AUTHENTICAION_IN_DWONFILE_URL = AUTHENTICAION_IN_DWONFILE_URL;
var PERSISTENCE_COLUMN_URL = "".concat(process.env.BASE_MODULE_API, "/listCustom/getFunctionListCustom");
exports.PERSISTENCE_COLUMN_URL = PERSISTENCE_COLUMN_URL;
var SAVE_PERSISTENCE_COLUMN_URL = "".concat(process.env.BASE_MODULE_API, "/listCustom/saveFunctionListCustom");
exports.SAVE_PERSISTENCE_COLUMN_URL = SAVE_PERSISTENCE_COLUMN_URL;

function list(module) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _skAxios.post)("".concat(module, "/list"), data);
}

function action(module) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _skAxios.post)("".concat(module, "/").concat(action), data);
}

function fetch(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _skAxios.post)("".concat(url), data);
}

function postByForm(formData, url) {
  return (0, _skAxios["default"])({
    url: url,
    method: 'post',
    data: _qs["default"].stringify(formData),
    notConverData: true,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    withCredentials: true
  });
}

function normalDownloadData(download, data) {
  var percentage = parseFloat(download.loaded / download.total) * 100 || 0;
  var totalSize = download.total;
  var loaded = download.loaded;
  var downloadSpecialId = data.downloadSpecialId;
  var status;

  if (loaded < totalSize) {
    status = 'uploading';
  } else if (loaded === totalSize) {
    status = 'success';
  }

  var downloader = {
    total: {
      percent: percentage,
      size: totalSize,
      loaded: loaded
    },
    files: [{
      loaded: loaded,
      size: totalSize,
      total: totalSize,
      name: data.fileName || _lang["default"].t('skyLoader.downloadFile'),
      status: status,
      percent: percentage,
      downloadSpecialId: downloadSpecialId,
      id: downloadSpecialId
    }],
    loaded: loaded,
    size: totalSize,
    downloadSpecialId: downloadSpecialId,
    id: downloadSpecialId,
    skyLoaderType: 'download'
  };
  return downloader;
}

function updateSkyLoader(downloader) {
  var skyLoaders = _store["default"].state.operate.skyLoaders;
  var oldLoader;

  var index = _lodash["default"].findIndex(skyLoaders, function (aloader) {
    if (aloader.downloadSpecialId === downloader.downloadSpecialId) {
      oldLoader = aloader;
      return true;
    }

    return false;
  });

  if (index >= 0) {
    // 同一个文件则更新，并保留之前的文件传输速率和速率描述信息
    if (oldLoader.files[0].fileSpeed) {
      downloader.files[0].fileSpeed = oldLoader.files[0].fileSpeed;
    }

    if (oldLoader.files[0].speedInfo) {
      downloader.files[0].speedInfo = oldLoader.files[0].speedInfo;
    }

    _store["default"].dispatch('UpdateSkyLoader', {
      index: index,
      downloader: downloader
    });
  } else {
    _store["default"].dispatch('AddSkyLoader', downloader); // 不同文件则添加

  }
}

function downloadFile(url, fileName) {
  if (url.indexOf('blob') !== -1) {
    var link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.download = fileName; // link.setAttribute('download', fileName)
    // var blob = new Blob(url) // 字符内容转变成blob地址
    // link.href = URL.createObjectURL(blob)

    document.body.appendChild(link);
    link.click(); // link.remove()

    document.body.removeChild(link);
  } else {
    window.open(url, '_self');
  }
} // export function download(module, action = '', data = {}) {
//   const CancelToken = axios.CancelToken; // 取消
//   let destroy;
//   // let downloader;
//   const url = `${process.env.AJAX_BASE_API}${module}/${action}`;
//   return request({
//     url,
//     method: 'get',
//     params: data,
//     responseType: 'arraybuffer',
//     timeout: 0,
//     onDownloadProgress: (download) => {
//       setTimeout(function() {
//         const xhr = download.target;
//         let isBusinessError = false;
//         if (xhr.response) {
//           let res;
//           let responseText= xhr.response;
//           if (responseText instanceof ArrayBuffer && responseText.byteLength <= 800) {
//               try {
//                 res = JSON.parse(decodeURIComponent(escape(String.fromCharCode.apply(null, new Uint8Array(responseText)))));
//               } catch (error) {
//                 console.log(error)
//               }
//           }
//           if (res && res.status === 'ERROR') {
//             isBusinessError = true;
//           }
//         }
//         if (!isBusinessError) {
//           destroy();
//           debugger
//           downloadFile(xhr.responseURL, data);
//         }
//       }, 300)
//     },
//     cancelToken: new CancelToken(function executor(cancel) {
//       // debugger
//       // 一个执行器函数接收一个取消函数作为参数
//       destroy = cancel;
//     }),
//     // transformResponse: [function (data) { // 对 data 进行任意转换处理
//     //   // debugger
//     //   let responseData;
//     //   let res
//     //   if (!downloader) {
//     //     responseData = null
//     //   } else if (downloader.total.size === downloader.loaded) {
//     //     responseData = data;
//     //     res = responseData; // 处理后端异常报错
//     //     if (res instanceof ArrayBuffer && res.byteLength <= 2000) {
//     //       try {
//     //         res = JSON.parse(decodeURIComponent(escape(String.fromCharCode.apply(null, new Uint8Array(res)))));
//     //       } catch (error) {
//     //         console.log(error)
//     //       }
//     //       if (res && res.status === 'ERROR') {
//     //         downloader.files[0].status = 'fail'
//     //         updateSkyLoader(downloader)
//     //       }
//     //     }
//     //   } else { // 下载到一半断网时，不会尝试续下载，所以当失败处理
//     //     downloader.files[0].status = 'fail'
//     //     updateSkyLoader(downloader)
//     //     responseData = {
//     //       status: 'ERROR',
//     //       msg: lang.t('skyLoader.dataError')
//     //     }
//     //   }
//     //   return responseData;
//     // }]
//   })
// }


function download(module) {
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var CancelToken = _axios["default"].CancelToken; // 取消

  var destroy;
  var downloader;
  return (0, _skAxios["default"])({
    url: "".concat(process.env.AJAX_BASE_API).concat(module, "/").concat(action),
    method: 'get',
    params: data,
    responseType: 'arraybuffer',
    timeout: 0,
    onDownloadProgress: function onDownloadProgress(download) {
      var MB = 1024 * 1024;

      if (download.total >= 100 * MB) {
        // 300m使用浏览器下载机制
        var xhr = download.target;
        destroy();
        downloadFile(xhr.responseURL, data.fileName);
        return;
      }

      downloader = normalDownloadData(download, data);

      if (!downloader.destroy) {
        downloader.destroy = destroy;
      }

      updateSkyLoader(downloader);
    },
    cancelToken: new CancelToken(function executor(cancel) {
      // 一个执行器函数接收一个取消函数作为参数
      destroy = cancel;
    }),
    transformResponse: [function (data) {
      // 对 data 进行任意转换处理
      var responseData;
      var res;

      if (!downloader) {
        responseData = null;
      } else if (downloader.total.size === downloader.loaded) {
        responseData = data;
        res = responseData; // 处理后端异常报错

        if (res instanceof ArrayBuffer && res.byteLength <= 2000) {
          try {
            res = JSON.parse(decodeURIComponent(escape(String.fromCharCode.apply(null, new Uint8Array(res)))));
          } catch (error) {
            console.log(error);
          }

          if (res.status === 'ERROR') {
            downloader.files[0].status = 'fail';
            updateSkyLoader(downloader);
          }
        }
      } else {
        // 下载到一半断网时，不会尝试续下载，所以当失败处理
        downloader.files[0].status = 'fail';
        updateSkyLoader(downloader);
        responseData = {
          status: 'ERROR',
          msg: _lang["default"].t('skyLoader.dataError')
        };
      }

      return responseData;
    }]
  });
}

function uploadFileFinish(formData) {
  formData.customData = JSON.stringify(formData.customData);
  return postByForm(formData, formData.finishUrl);
}
/**
 *
 * @description 配置向导信息：获取信息
 * @param {Object} data
 */


function getConfigurationWizardInfo() {
  return (0, _skAxios.get)("".concat(moduleConfigWizard, "/get"));
}
/**
 *
 * @description 配置向导信息：设置信息
 * @param {Object} data
 */


function setConfigurationWizardInfo(_ref) {
  var show = _ref.show,
      index = _ref.index,
      userIndex = _ref.userIndex,
      isJoinUserExperiencePlan = _ref.isJoinUserExperiencePlan;
  userIndex = userIndex !== undefined ? userIndex : _store["default"].state.permission.configurationWizardUserIndex;
  isJoinUserExperiencePlan = isJoinUserExperiencePlan !== undefined ? isJoinUserExperiencePlan : _store["default"].state.permission.isJoinUserExperiencePlan;
  var data = {
    show: show,
    index: index,
    isJoinUserExperiencePlan: isJoinUserExperiencePlan,
    customDataArr: [{
      key: 'userIndex',
      value: userIndex
    }]
  };
  return (0, _skAxios.post)("".concat(moduleConfigWizard, "/set"), data);
}

function checkAdminPwd(_x) {
  return _checkAdminPwd.apply(this, arguments);
}

function _checkAdminPwd() {
  _checkAdminPwd = (0, _asyncToGenerator2["default"])( /*#__PURE__*/regeneratorRuntime.mark(function _callee(pwd) {
    var bcryptjs;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.resolve().then(function () {
              return (0, _interopRequireWildcard2["default"])(require('bcryptjs'));
            });

          case 2:
            bcryptjs = _context.sent;
            pwd = (0, _utils.bcryptEncryption)(bcryptjs, pwd);
            return _context.abrupt("return", (0, _skAxios.post)("".concat(ADMIN, "/validateAdminPwd"), {
              pwd: pwd
            }));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _checkAdminPwd.apply(this, arguments);
}